import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import getIsInProductMagazine from 'selectors/getIsInProductMagazine';
import InProductHeader from './inProductHeader';
import DefaultHeader from './defaultHeader';

const Header = ({ isInProductMagazine }) => (
  isInProductMagazine ? <InProductHeader /> : <DefaultHeader />
);

Header.propTypes = {
  isInProductMagazine: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isInProductMagazine: getIsInProductMagazine(state),
});

const withRedux = connect(
  mapStateToProps,
);

export default withRedux(Header);
